// extracted by mini-css-extract-plugin
export default {"box":"Img_box__AGAXE"};